export const usaStatesAbbr = [
  { label: "Alabama", value: "AL", id: "01" },
  { label: "Alaska", value: "AK", id: "02" },
  { label: "American Samoa", value: "AS", id: "60" },
  { label: "Arizona", value: "AZ", id: "04" },
  { label: "Arkansas", value: "AR", id: "05" },
  { label: "California", value: "CA", id: "06" },
  { label: "Colorado", value: "CO", id: "08" },
  { label: "Connecticut", value: "CT", id: "09" },
  { label: "Delaware", value: "DE", id: "10" },
  { label: "District of Columbia", value: "DC", id: "11" },
  { label: "States of Micronesia", value: "FM", id: "64" },
  { label: "Florida", value: "FL", id: "12" },
  { label: "Georgia", value: "GA", id: "13" },
  { label: "Guam", value: "GU", id: "66" },
  { label: "Hawaii", value: "HI", id: "15" },
  { label: "Idaho", value: "ID", id: "16" },
  { label: "Illinois", value: "IL", id: "17" },
  { label: "Indiana", value: "IN", id: "18" },
  { label: "Iowa", value: "IA", id: "19" },
  { label: "Kansas", value: "KS", id: "20" },
  { label: "Kentucky", value: "KY", id: "21" },
  { label: "Louisiana", value: "LA", id: "22" },
  { label: "Maine", value: "ME", id: "23" },
  { label: "Marshall Islands", value: "MH", id: "68" },
  { label: "Maryland", value: "MD", id: "24" },
  { label: "Massachusetts", value: "MA", id: "25" },
  { label: "Michigan", value: "MI", id: "26" },
  { label: "Minnesota", value: "MN", id: "27" },
  { label: "Mississippi", value: "MS", id: "28" },
  { label: "Missouri", value: "MO", id: "29" },
  { label: "Montana", value: "MT", id: "30" },
  { label: "Nebraska", value: "NE", id: "31" },
  { label: "Nevada", value: "NV", id: "32" },
  { label: "New Hampshire", value: "NH", id: "33" },
  { label: "New Jersey", value: "NJ", id: "34" },
  { label: "New Mexico", value: "NM", id: "35" },
  { label: "New York", value: "NY", id: "36" },
  { label: "North Carolina", value: "NC", id: "37" },
  { label: "North Dakota", value: "ND", id: "38" },
  { label: "Northern Mariana Islands", value: "MP", id: "69" },
  { label: "Ohio", value: "OH", id: "39" },
  { label: "Oklahoma", value: "OK", id: "40" },
  { label: "Oregon", value: "OR", id: "41" },
  { label: "Palau", value: "PW", id: "70" },
  { label: "Pennsylvania", value: "PA", id: "42" },
  { label: "Puerto Rico", value: "PR", id: "72" },
  { label: "Rhode Island", value: "RI", id: "44" },
  { label: "South Carolina", value: "SC", id: "45" },
  { label: "South Dakota", value: "SD", id: "46" },
  { label: "Tennessee", value: "TN", id: "47" },
  { label: "Texas", value: "TX", id: "48" },
  { label: "Utah", value: "UT", id: "49" },
  { label: "Vermont", value: "VT", id: "50" },
  { label: "Virgin Islands", value: "VI", id: "78" },
  { label: "Virginia", value: "VA", id: "51" },
  { label: "Washington", value: "WA", id: "53" },
  { label: "West Virginia", value: "WV", id: "54" },
  { label: "Wisconsin", value: "WI", id: "55" },
  { label: "Wyoming", value: "WY", id: "56" },
];

export const ZOOM = {
  MIN: 4,
  MAX: 22,
  COUNTIES: 5,
};

export const BOUNDS = [
  [-179.99, 16.01619],
  [-64.46466, 71.757764],
];

export const CONCENTRIC_COLORS = [
  "rgba(129, 197, 64, 1)",
  "rgba(245, 181, 46, 1)",
  "rgba(237, 91, 53, 1)",
  "rgba(0,0,0, 1)",
];

export const MULTILINE_COLORS = [
  "#03045E",
  "#0077B6",
  "#00A396",
  "#00B4D8",
  "#81C540",
  "#F5B52E",
  "#EA225E",
  "#C22286",
  "#ED5B35",
  "#FFB86F",
  "#34D1BF",
  "#06A77D",
];

export const GROUPED_BAR_COLORS = ["rgb(97, 46, 141)", "rgb(245, 181, 46)"];
